export const getStatus = store => store.status
export const getApiAvailability = store => store.status.apiAvailable
export const getIsOffline = store => store.status.isOffline
export const getNeedRestart = store => store.status.needRestart
export const getLastPong = store => store.status.pong
export const getIntegrationStatus = store => store.status.integration
export const getGeneralErrors = store => store.status.errors
